var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b06550;}.cls-2{fill:#4c5665;}.cls-3{fill:#c8785c;}.cls-4{fill:#face53;}.cls-5{fill:#fed049;}.cls-6{fill:#49aaee;}.cls-7{fill:#a4b0c0;}.cls-8{fill:#d0d7df;}.cls-9{fill:#9c5946;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    rx: 1,
    ry: 1,
    width: 44,
    x: 2,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    rx: 1,
    ry: 1,
    width: 44,
    x: 2,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2,
    rx: 1,
    ry: 1,
    width: 44,
    x: 2,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    rx: 1,
    ry: 1,
    width: 48,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 3,
    rx: 1,
    ry: 1,
    width: 48,
    y: 42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.5,3h0A1.5,1.5,0,0,1,8,4.5V42a0,0,0,0,1,0,0H5a0,0,0,0,1,0,0V4.5A1.5,1.5,0,0,1,6.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.5,3h0A1.5,1.5,0,0,1,43,4.5V42a0,0,0,0,1,0,0H40a0,0,0,0,1,0,0V4.5A1.5,1.5,0,0,1,41.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.5,3h0A1.5,1.5,0,0,1,43,4.5V42a0,0,0,0,1,0,0H40a0,0,0,0,1,0,0V4.5A1.5,1.5,0,0,1,41.5,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 12,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 12,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 18,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 25,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 19,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 31,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 19,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 13,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    height: 8,
    rx: 2,
    ry: 2,
    width: 4,
    x: 25,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 2,
    width: 1,
    x: 8,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 2,
    width: 1,
    x: 8,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 2,
    width: 1,
    x: 8,
    y: 34
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.fb5738e4bee800e18fbe7ecfda3dac10.svg";
export { ForwardRef as ReactComponent };